<template>
    <v-container fluid grid-list-md class="grey lighten-4">
        <v-layout row class="padding">
            <v-flex xs12 sm12>
                <v-layout row class="padding">
                    <v-flex xs12 sm12>
                        <UsersPerProjectPickers @change="requestData"></UsersPerProjectPickers>
                        <Loader v-if="loading"></Loader>
                    </v-flex>
                </v-layout>
                <v-layout row v-for="user in items" :key="user.id">
                    <v-flex xs12 sm12>
                        <v-card class="height-auto">
                            <v-card-title primary-title>
                                <v-avatar size="76px" slot="activator">
                                    <img :src="user.avatar_url" alt="">
                                </v-avatar>
                                <div>
                                    <div class="headline card-title-margin">{{user.first_name}}</div>
                                </div>
                                <div>
                                    <div class="headline"> {{user.last_name}}</div>
                                </div>
                            </v-card-title>
                            <v-list two-line class="height">
                                <v-list-tile class="list-tile-margin" @click="">
                                    <v-list-tile-action>
                                        <v-icon color="grey">attach_money</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            Total Revenue: {{user.Analytics.Revenue}}$
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-icon dark>add</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-list-tile class="list-tile-margin" @click="">
                                    <v-list-tile-action>
                                        <v-icon color="grey">all_inclusive</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            Total Hours: {{user.Analytics.totalHours}}
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-icon dark>add</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider inset></v-divider>
                                <v-list-tile class="list-tile-margin" @click="">
                                    <v-list-tile-action>
                                        <v-icon color="grey">trending_up</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            Total Billable Hours: {{user.Analytics.billableHours}}
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-icon dark>add</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider inset></v-divider>
                                <v-list-tile class="list-tile-margin" @click="">
                                    <v-list-tile-action>
                                        <v-icon color="grey">trending_flat</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            Total Non Billable Hours: {{user.Analytics.nonBillableHours}}
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-icon dark>add</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>
                        </v-card>
                        <v-layout row>
                            <v-flex xs12 sm6>
                                <v-card class="height-auto">
                                    <v-card-title>
                                        Time Tracking
                                    </v-card-title>
                                    <UserPerProjectBarChart :analytics="user.Analytics"></UserPerProjectBarChart>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-card class="height-auto">
                                    <v-card-title>
                                        Time Tracking
                                    </v-card-title>
                                    <UserPerProjectPieChart :analytics="user.Analytics"></UserPerProjectPieChart>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>


<script>
    import {
        Api
    } from '../../../../services';
    import queryString from 'query-string';
    import Loader from '../../Components/Loader.vue';
    import UsersPerProjectPickers from './UsersPerProjectPickers.vue'
    import UserPerProjectBarChart from './UserPerProjectBarChart.vue';
    import UserPerProjectPieChart from './UserPerProjectPieChart.vue';

    export default {
        name: 'UsersPerProject',
        data() {
            return {
                msg: 'Pleaase wait ...',
                subdomain: 'hat',
                client_id: '-PsAjA85atcU6QvOwHP2qA',
                redirect_uri: 'http://localhost:8080',
                items: [],
                loading: true,
                params: {
                    from: new Date(new Date() - 1000 * 60 * 60 * 24 * 31 - 1).toISOString(),
                    to: new Date().toISOString()
                }
            }
        },
        components: {
            Loader,
            UsersPerProjectPickers,
            UserPerProjectBarChart,
            UserPerProjectPieChart
        },
        created() {
            let parsed = queryString.parse(location.search);
            if (parsed.user_id)
                this.params.user_id = parsed.user_id;
            Api.Analytics()
            .UsersPerProject(this.params)
            .then((res) => this.items = res.data)
            .then(() => this.loading = false)
            .catch(err => {
                this.loading = false
            })
        },
        methods: {
            auth() {
            },
            requestData(params) {
                this.loading = true;
                Api
                .Analytics()
                .UsersPerProject(params)
                .then((res) => this.items = res.data)
                .then(() => this.loading = false)
                .catch(err => {
                    this.loading = false
                })
            },
            submit() {

            }
        }
    }
</script>

<style>
    .height {
        height: 100%
    }

    .height-auto {
        height: auto;
    }

    .height .list__tile {
        height: 100%
    }

    .card__title {
        font-size: 2rem;
    }

    .list-tile-margin {
        height: 40px;
    }

    .card-title-margin {
        margin-left: 23px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Analytics/UsersPerProject/UsersPerProject.vue